import type { CoviActivity, CoviChatItem, CoviToolCounts } from "../model/types"
import { toolState, toolTraceCounts } from "./toolSteps"

/** Keep transcript rendering and storage bounded independently of the number of invocations. */
export const MAX_VISIBLE_TOOL_STEPS = 24

type TraceStep = CoviActivity & {
  status?: string
  isError?: boolean
  is_error?: boolean
  omittedSteps?: CoviToolCounts
  traceTruncated?: boolean
}

export function boundToolTrace<T extends TraceStep>(
  steps: T[],
): (T & { omittedSteps?: CoviToolCounts; traceTruncated?: boolean })[] {
  const visible = steps.slice(0, MAX_VISIBLE_TOOL_STEPS)
  if (steps.length <= MAX_VISIBLE_TOOL_STEPS) {
    return visible
  }
  const omitted = toolTraceCounts(steps)
  for (const step of visible) {
    omitted[toolState(step)] -= 1
  }
  return visible.map((step, index) => ({
    ...step,
    omittedSteps: index === visible.length - 1 ? omitted : undefined,
    traceTruncated: index === visible.length - 1,
  }))
}

export function boundTranscriptToolSteps(
  items: CoviChatItem[],
): CoviChatItem[] {
  const bounded: CoviChatItem[] = []
  let tools: Extract<CoviChatItem, { kind: "tool" }>[] = []
  const flush = () => {
    bounded.push(...boundToolTrace(tools))
    tools = []
  }
  for (const item of items) {
    if (item.kind === "tool") {
      tools.push(item)
    } else {
      flush()
      bounded.push(item)
    }
  }
  flush()
  return bounded
}
